import React, { useContext, useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import "./Create.css";
import Select from "react-select";
import Header from "../../../Header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSave from "../../../common/ModelSave";
import { useNavigate } from "react-router";
import { putData } from "../../../../utils/api";
import JoditEditor from "jodit-react";
import { variant_type } from "../../../../utils/common";
import DoubleVarient from "../DoubleVarient";
function Edit() {
  const { id } = useParams();

  const navigate = useNavigate();
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
    getDimension,
  } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
    setValue,
    trigger,
  } = useForm({
    defaultValues: {
      variants: [{ name: "", price: "", mrp: "", image: "", description: "" }], // Default empty field
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "variants",
  });
  const variantType = watch("variant_type_id");
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const imageFiles = watch("images");

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data?.name);
      DataToSend.append("price", data?.price);
      DataToSend.append("mrp", data?.mrp);

      DataToSend.append("manufacturer", data?.manufacturer);
      DataToSend.append("description", data?.description);
      DataToSend.append("composition", data?.composition);
      DataToSend.append("advantages", data?.advantages);
      DataToSend.append("preservation", data?.preservation);
      DataToSend.append("tax_percentage", data?.tax_percentage);
      DataToSend.append("p_category_id", data?.p_category_id?.value);
      // DataToSend.append("p_sub_category_id", data?.p_sub_category_id?.value);
      // DataToSend.append("shape_id", data?.shape_id?.value);
      DataToSend.append("variant_type_id", 1);
      // DataToSend.append(
      //   "p_child_category_id",
      //   data?.p_child_category_id?.value,
      // );
      // DataToSend.append("unit_id", data?.unit_id?.value);

      if (data?.brand_id?.value) {
        DataToSend.append("brand_id", data?.brand_id?.value);
      }

      DataToSend.append("item_code", data?.item_code);
      DataToSend.append("lic_no", data?.lic_no);
      DataToSend.append("tag", data?.tag);
      DataToSend.append("measurements", data?.measurements);
      DataToSend.append("expity_date_days", data?.expity_date_days);

      // if (data?.preservation_status) {
      DataToSend.append("preservation_status", data?.preservation_status===true?1:0);
      // }

      // if (data?.advantages_status) {
      DataToSend.append("advantages_status", data?.advantages_status ===true?1:0);
      // }

      // if (data?.composition_status) {
      DataToSend.append("composition_status", data?.composition_status===true?1:0);
      // }

      // if (data?.description_status) {
      DataToSend.append("description_status", data?.description_status===true?1:0);
      // }

      DataToSend.append("made_in_id", data?.made_in_id?.value);

      if (data?.image && data?.image[0]) {
        DataToSend.append("image", data.image[0]);
      }
      if (data?.video && data?.video[0]) {
        DataToSend.append("video", data.video[0]);
      }

      // Append the images (multiple files)
      // if (data?.images && data?.images.length > 0) {
      //   for (let i = 0; i < data.images.length; i++) {
      //     DataToSend.append("images", data.images[i]);
      //   }
      // }

      if (Array.isArray(data?.images)) {
        data.images.forEach((image) => {
          if (image instanceof File) {
            DataToSend.append("images", image);
          }
        });
      }

      const variants = [];

      data.variants?.forEach((variant) => {
        const singleVariant = {
          id: variant?.id,
          price: variant?.price ?? null,
          mrp: variant?.mrp ?? null,
          metal_id: variant?.metal_id?.value ?? null,
          description: variant?.description ?? null,
          double_variants: [],
        };

        if (Array.isArray(variant?.double_variants)) {
          variant.double_variants.forEach((doubleVal) => {
            const doubleVariant = {
              id: doubleVal?.id,
              mrp: doubleVal?.mrp ?? null,
              price: doubleVal?.price ?? null,
              size_id: doubleVal?.size_id?.value ?? null,
              triple_variants: [],
            };

            if (Array.isArray(doubleVal?.triple_variants)) {
              doubleVal.triple_variants.forEach((tripleVal) => {
                doubleVariant.triple_variants.push({
                  id: tripleVal?.id,
                  mrp: tripleVal?.mrp ?? null,
                  price: tripleVal?.price ?? null,
                  diamond_id: tripleVal?.diamond_id?.value ?? null,
                });
              });
            }

            singleVariant.double_variants.push(doubleVariant);
          });
        }

        variants.push(singleVariant);
      });
      DataToSend.append("variants", JSON.stringify(variants));

      let response;
      if (data?.name) {
        response = await putData(`/admin/products/${id}`, DataToSend);
      }

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.data });
        reset();
        setTimeout(() => {
          setShowModal(0);
          navigate("/products");
        }, 1000);
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
        setTimeout(() => {
          setShowModal(0);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [Countries, setCountries] = useState([]);

  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [Farmer, setFarmer] = useState([]);
  const [DeliveryType, setDeliveryType] = useState([]);
  const [shapes, setShape] = useState([]);
  const watchedUnit = watch("unit_id");

  const getAllBrands = async () => {
    const response = await getData(`/common/masters/all-brands`);
    if (response?.success) {
      setBrands(await Select2Data(response?.data, "brand_id"));
    }
  };

  const getAllShapes = async () => {
    const response = await getData(`/common/masters/all-shape`);
    if (response?.success) {
      setShape(await Select2Data(response?.data, "shape_id"));
    }
  };
  const getAllUnits = async () => {
    const response = await getData(`/common/masters/all-units`);
    if (response?.success) {
      setUnits(await Select2Data(response?.data, "unit_id"));
    }
  };
  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-p-category");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const getAllSubCategories = async (id) => {
    const response = await getData(`/common/masters/all-p-sub-category/${id}`);
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "p_sub_category_id"));
    }
  };
  const getAllChildCategories = async (id) => {
    const response = await getData(
      `/common/masters/all-p-child-category/${id}`,
    );
    if (response?.success) {
      setChildCategories(
        await Select2Data(response?.data, "p_child_category_id"),
      );
    }
  };
  const getAllCountries = async () => {
    const response = await getData(`/common/masters/all-country`);
    if (response?.success) {
      setCountries(await Select2Data(response?.data, "made_in_id"));
    }
  };

  const getAllDeliveryType = async () => {
    const response = await getData(`/common/masters//all-delivery-type`);
    if (response?.success) {
      setDeliveryType(await Select2Data(response?.data, "farmer_id"));
    }
  };
  useEffect(() => {
    getAllBrands();
    getAllUnits();
    getAllCategories();
    getAllCountries();

    getAllDeliveryType();
    getAllShapes();
  }, []);

  const GetEditData = async () => {
    const response = await getData(`/admin/products/${id}`);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, [id]);

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [imagePreviews, setImagePreviews] = useState([]);

  const handleImagesChange = (e) => {
    const files = Array.from(e.target.files || []);

    if (!files.length) return;

    const existingImages = getValues("images");

    const existingArray = Array.isArray(existingImages) ? existingImages : [];

    const updatedImages = [...existingArray, ...files];

    setValue("images", updatedImages, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    // Generate previews
    const newPreviews = [];

    files.forEach((file) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        newPreviews.push(reader.result);

        if (newPreviews.length === files.length) {
          setImagePreviews((prev) => [...prev, ...newPreviews]);
        }
      };

      reader.readAsDataURL(file);
    });

    e.target.value = "";
  };

  const handleRemoveImage = async (imageIndex) => {
    if (!window.confirm("Delete this image?")) return;

    const images = getValues("images") || [];

    const imagesArray = Array.isArray(images) ? images : Array.from(images);

    const target = imagesArray[imageIndex];

    // Existing API image
    if (target?.id) {
      try {
        await deleteData(`/admin/products/image-delete/${target.id}`);
      } catch (error) {
        console.error("Failed to delete image:", error);
        alert("Failed to delete image");
        return;
      }
    }

    // Remove from form
    const updatedImages = imagesArray.filter(
      (_, index) => index !== imageIndex,
    );

    setValue("images", updatedImages, {
      shouldDirty: true,
      shouldValidate: true,
    });

    // Remove preview
    setImagePreviews((prev) => prev.filter((_, index) => index !== imageIndex));
  };

  const [videoPreviews, setVideoPreview] = useState(null);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setVideoPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [Metals, setMetal] = useState([]);
  const getAllMetal = async () => {
    const response = await getData(`/common/masters/all-metal`);
    if (response?.success) {
      setMetal(await Select2Data(response?.data, "metal_id"));
    }
  };

  const [Sizes, setSize] = useState([]);
  const getAllSize = async () => {
    const response = await getData(`/common/masters/all-size`);
    if (response?.success) {
      setSize(await Select2Data(response?.data, "size_id"));
    }
  };

  const [Diamonds, setDiamond] = useState([]);
  const getAllDiamond = async () => {
    const response = await getData(`/common/masters/all-diamond`);
    if (response?.success) {
      setDiamond(await Select2Data(response?.data, "diamond_id"));
    }
  };
  const [VarientType, setVarientType] = useState([]);
  const getAllVarientType = async () => {
    const response = await getData(`/common/masters/all-variant-type`);
    if (response?.success) {
      setVarientType(await Select2Data(response?.data, "stock_type_id"));
    }
  };

  useEffect(() => {
    getAllSize();
    getAllDiamond();
    getAllMetal();
    getAllVarientType();
  }, []);

  return (
    <>
      <Header title={"Edit Product"} link={"/employee/employee_details"} />
      <section className="Create">
        {/* back button start */}
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/products`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {/* back button end */}

        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* 1. Order Details start */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>1. Product Category</h6>
            </div>
            <div className="package-details-section">
              <div className="pending-table ">
                <div className="row ">
                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_category_id`}
                      control={control}
                      rules={{
                        required: "Select Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={categories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllSubCategories(selectedValue?.value);
                            setValue("p_sub_category_id", "");
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_category_id && (
                      <span className="text-danger">
                        {errors.p_category_id.message}
                      </span>
                    )}
                  </div>

                  {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Sub Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_sub_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Sub Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_sub_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={subCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllChildCategories(selectedValue?.value);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_sub_category_id && (
                      <span className="text-danger">
                        {errors.p_sub_category_id.message}
                      </span>
                    )}
                  </div> */}

                  {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Child Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_child_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Child Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_child_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={childCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_child_category_id && (
                      <span className="text-danger">
                        {errors.p_child_category_id.message}
                      </span>
                    )}
                  </div> */}

                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Brand</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`brand_id`} // name of the field
                      control={control}
                      rules={
                        {
                          // required: "Select Sub Category",
                        }
                      }
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.brand_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={brands}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.brand_id && (
                      <span className="text-danger">
                        {errors.brand_id.message}
                      </span>
                    )}
                  </div>

                  {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Style</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`shape_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Shape",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.shape_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={shapes}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.shape_id && (
                      <span className="text-danger">
                        {errors.shape_id.message}
                      </span>
                    )}
                  </div> */}

                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Made In</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`made_in_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Made In",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.made_in_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={Countries}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.made_in_id && (
                      <span className="text-danger">
                        {errors.made_in_id.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 2. Package Details start */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>2. Product</h6>
            </div>
            <div className="package-details-section">
              <Row>
                <Col>
                  {/* Package Weight */}
                  <Row className="detail-row">
                    <Col md={6}>
                      <div className="detail-label">Name</div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="text"
                          name={`name`}
                          placeholder="name"
                          className={classNames("", {
                            "is-invalid": errors?.name, // Adjusted error checking
                          })}
                          {...register(`name`, {
                            required: "Name is required",
                            validate: (value) =>
                              value.length <= 200 ||
                              "Data must be 200 characters or less",
                          })}
                        />
                      </div>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Col>
                  </Row>

                  <Row className="detail-row">
                    <Col md={6}>
                      <div className="detail-label">Thumbnail Upload image</div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="file"
                          name="image"
                          accept="image/*, video/*"
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          {...register("image", {
                            // validate: async (value) => {
                            //   if (
                            //     typeof value !== "string" &&
                            //     value &&
                            //     value[0]
                            //   ) {
                            //     const file = value[0];
                            //     const fileTypes = [
                            //       "jpg",
                            //       "jpeg",
                            //       "png",
                            //       "webp",
                            //     ];
                            //     const fileType = file.name
                            //       .split(".")
                            //       .pop()
                            //       .toLowerCase();
                            //     if (!fileTypes.includes(fileType)) {
                            //       return `Please upload a valid file format. (${fileTypes.join(
                            //         ", ",
                            //       )})`;
                            //     }
                            //     const sizes = await getDimension(file);
                            //     if (
                            //       sizes.width !== 928 ||
                            //       sizes.height !== 945
                            //     ) {
                            //       return "Image width and height must be 928 px and 945 px";
                            //     }
                            //     const fileSize = Math.round(file.size / 1024); // in KB
                            //     if (fileSize > 500) {
                            //       return "File size must be less than 500KB";
                            //     }
                            //   }
                            // },
                          })}
                          onChange={handleImageChange}
                        />
                      </div>

                      {errors.image && (
                        <span className="text-danger">
                          {errors.image.message}
                        </span>
                      )}
                    </Col>
                  </Row>

                  {/* <Row className="detail-row">
                    <Col md={6}>
                      <div className="detail-label">Video</div>
                    </Col>

                    <Col lg={6} md={6}>
                      <Form.Control
                        type="file"
                        accept="video/mp4"
                        className={classNames({
                          "is-invalid": errors?.video,
                        })}
                        {...register("video", {
                          validate: (value) => {
                            if (typeof value === "string") return true;

                            // New upload case
                            if (value && value[0]) {
                              const file = value[0];
                              const allowedTypes = ["mp4"];
                              const ext = file.name
                                .split(".")
                                .pop()
                                .toLowerCase();

                              if (!allowedTypes.includes(ext)) {
                                return "Only MP4 video is allowed";
                              }
                            }
                            return true;
                          },
                        })}
                        onChange={(e) => {
                          handleVideoChange(e); 
                        }}
                      />

                      {errors?.video && (
                        <span className="text-danger">
                          {errors.video.message}
                        </span>
                      )}
                    </Col>
                  </Row> */}

                  {/* <Row className="detail-row">
                    <Col md={6}>
                      <div className="detail-label">Unit</div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="">
                        <Controller
                          className="select-contoller"
                          name={`unit_id`} 
                          control={control}
                          rules={{
                            required: "Select Unit",
                          }}
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors?.unit_id
                                    ? "red"
                                    : baseStyles.borderColor,
                                }),
                              }}
                              
                              options={units}
                              onChange={(selectedValue) => {
                                onChange(selectedValue);
                              }}
                              onBlur={onBlur}
                              value={value}
                              ref={ref}
                            />
                          )}
                        />
                      </div>
                      {errors.unit_id && (
                        <span className="text-danger">
                          {errors.unit_id.message}
                        </span>
                      )}
                    </Col>
                  </Row> */}
                </Col>

                <Col lg={4} md={4} className="ms-5">
                  {typeof getValues("image") === "string" ? (
                    // If image is a string (URL), show the preview
                    <div className="image-preview-container ms-5">
                      {getValues("image").endsWith(".mp4") ||
                      getValues("image").endsWith(".mov") ||
                      getValues("image").endsWith(".avi") ? (
                        // If the file is a video, show a video element
                        <video
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="preview-video"
                          // controls
                          autoPlay
                          muted
                          loop
                        >
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        // If it's an image, show the image preview
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                          width={50}
                        />
                      )}
                    </div>
                  ) : (
                    // If the image is not a string (i.e., it's a file or URL in preview), show that
                    imagePreview && (
                      <div className="image-preview-container ms-5">
                        {imagePreview.includes("video") ? (
                          // If the preview is a video, show a video element
                          <video
                            src={imagePreview}
                            alt="Preview"
                            className="preview-video"
                            // controls
                            autoPlay
                            muted
                            loop
                          >
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          // Otherwise, show an image
                          <img
                            src={imagePreview}
                            alt="Category Preview"
                            width={150}
                          />
                        )}
                      </div>
                    )
                  )}

                  {typeof getValues("video") === "string" ? (
                    // If image is a string (URL), show the preview
                    <div className="image-preview-container ms-5">
                      {getValues("video").endsWith(".mp4") ||
                      getValues("video").endsWith(".mov") ||
                      getValues("video").endsWith(".avi") ? (
                        // If the file is a video, show a video element
                        <video
                          src={IMG_URL + getValues("video")}
                          alt="Preview"
                          className="preview-video"
                          // controls
                          autoPlay
                          muted
                          loop
                          width={100}
                        >
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        // If it's an image, show the image preview
                        <img
                          src={IMG_URL + getValues("video")}
                          alt="Preview"
                          className="image-preview"
                          width={50}
                        />
                      )}
                    </div>
                  ) : (
                    // If the image is not a string (i.e., it's a file or URL in preview), show that
                    videoPreviews && (
                      <div className="image-preview-container ms-5">
                        {videoPreviews.includes("video") ? (
                          // If the preview is a video, show a video element
                          <video
                            src={videoPreviews}
                            alt="Preview"
                            className="preview-video"
                            // controls
                            autoPlay
                            muted
                            loop
                            width={100}
                          >
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          // Otherwise, show an image
                          <img
                            src={videoPreviews}
                            alt="Category Preview"
                            width={150}
                          />
                        )}
                      </div>
                    )
                  )}
                </Col>
              </Row>
            </div>
          </div>
          {/* 2. Package Details end */}

          {/* 3. Pickup Slot Details start */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>3. Details</h6>
            </div>
            <div className="package-details-section">
              <Row className="detail-row">
                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Tax Percentage</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`tax_percentage`}
                          placeholder="Tax Percentage (%)"
                          className={classNames("", {
                            "is-invalid": errors?.tax_percentage, // Adjusted error checking
                          })}
                          {...register(`tax_percentage`, {
                            required: "Tax Percentage is required",
                            validate: (value) => {
                              const numericValue = parseFloat(value);
                              if (numericValue > 100) {
                                return "Tax percentage cannot exceed 100";
                              }
                              return true;
                            },
                          })}
                          onKeyDown={(e) => {
                            // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                            if (
                              !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight" &&
                              e.key !== "."
                            ) {
                              e.preventDefault(); // Prevent the event if it's not allowed
                            }

                            // Prevent entering more than one decimal point
                            if (e.key === "." && e.target.value.includes(".")) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            // Ensure the value stays within the range of 0 to 100
                            const value = e.target.value;
                            if (parseFloat(value) > 100) {
                              e.target.value = "100"; // Set the value to 100 if it exceeds
                            }
                          }}
                        />
                        {errors.tax_percentage && (
                          <span className="text-danger">
                            {errors.tax_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Manufacturer</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`manufacturer`}
                          placeholder="manufacturer"
                          className={classNames("", {
                            "is-invalid": errors?.manufacturer, // Adjusted error checking
                          })}
                          {...register(`manufacturer`, {
                            required: "Manufacturer is required",
                          })}
                        />
                        {errors.manufacturer && (
                          <span className="text-danger">
                            {errors.manufacturer.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>License No</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`lic_no`}
                          placeholder="License No"
                          className={classNames("", {
                            "is-invalid": errors?.lic_no, // Adjusted error checking
                          })}
                          {...register(`lic_no`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.lic_no && (
                          <span className="text-danger">
                            {errors.lic_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Tag</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`tag`}
                          placeholder="Tag"
                          className={classNames("", {
                            "is-invalid": errors?.tag, // Adjusted error checking
                          })}
                          {...register(`tag`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.tag && (
                          <span className="text-danger">
                            {errors.tag.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                {/* <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Measurements</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`measurements`}
                          placeholder="measurements"
                          className={classNames("", {
                            "is-invalid": errors?.measurements, // Adjusted error checking
                          })}
                          {...register(`measurements`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.measurements && (
                          <span className="text-danger">
                            {errors.measurements.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col> */}
              </Row>

              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <Form.Label>Overview </Form.Label>

                        <Form.Check
                          type="switch"
                          id="description_status" // Give it an id for accessibility
                          label=""
                          name="description_status"
                          checked={watch("description_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("description_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.description_status,
                          })}
                        />
                      </Form.Group>
                      <Form.Group>
                        <Controller
                          name="description"
                          control={control}
                          rules={
                            {
                              // required: "description is required.",
                              // maxLength: {
                              //   value: 600,
                              //   message:
                              //     "content must be at most 600 characters long.",
                              // },
                            }
                          } // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("description");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.description && (
                          <span className="text-danger">
                            {errors.description.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <Form.Label>Advantages </Form.Label>
                        <Form.Check
                          type="switch"
                          id="advantages_status" // Give it an id for accessibility
                          label=""
                          name="advantages_status"
                          checked={watch("advantages_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("advantages_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.advantages_status,
                          })}
                        />
                      </Form.Group>
                      <Form.Group>
                        {/* <Form.Control
                          type="text"
                          as={"textArea"}
                          name={`advantages`}
                          placeholder="Advantages"
                          className={classNames("", {
                            "is-invalid": errors?.advantages, // Adjusted error checking
                          })}
                          {...register(`advantages`, {
                            required: "Advantages is required",
                          })}
                        /> */}
                        <Controller
                          name="advantages"
                          control={control}
                          rules={
                            {
                              // required: "advantages is required.",
                              // maxLength: {
                              //   value: 600,
                              //   message:
                              //     "content must be at most 600 characters long.",
                              // },
                            }
                          } // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("advantages");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.advantages && (
                          <span className="text-danger">
                            {errors.advantages.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <Form.Label>Preservation </Form.Label>
                        <Form.Check
                          type="switch"
                          id="preservation_status" // Give it an id for accessibility
                          label=""
                          name="preservation_status"
                          checked={watch("preservation_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("preservation_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.preservation_status,
                          })}
                        />
                      </Form.Group>
                      <Form.Group>
                        <Controller
                          name="preservation"
                          control={control}
                          rules={
                            {
                              // required: "preservation is required.",
                              // maxLength: {
                              //   value: 600,
                              //   message:
                              //     "content must be at most 600 characters long.",
                              // },
                            }
                          } // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("preservation");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.preservation && (
                          <span className="text-danger">
                            {errors.preservation.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <Form.Label>Composition </Form.Label>
                        <Form.Check
                          type="switch"
                          id="composition_status" // Give it an id for accessibility
                          label=""
                          name="composition_status"
                          checked={watch("composition_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("composition_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.composition_status,
                          })}
                        />
                      </Form.Group>

                      <Form.Group>
                        <Controller
                          name="composition"
                          control={control}
                          rules={
                            {
                              // required: "composition is required.",
                              // maxLength: {
                              //   value: 600,
                              //   message:
                              //     "content must be at most 600 characters long.",
                              // },
                            }
                          } // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("composition");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.composition && (
                          <span className="text-danger">
                            {errors.composition.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          {/* 3. Pickup Slot Details end */}

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>4. Images Upload image (928 × 945 px).</h6>
            </div>

            <div className="package-details-section">
              <Row className="detail-row">
                <Col lg={4} md={4}>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="file"
                      name="images"
                      multiple
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.images,
                      })}
                      accept="image/*"
                      onChange={handleImagesChange}
                    />
                  </div>

                  {errors.images && (
                    <span className="text-danger">{errors.images.message}</span>
                  )}
                </Col>

                <div className="d-flex flex-wrap mt-2">
                  {imageFiles &&
                    Array.from(imageFiles).map((imageObj, index) => {
                      const isNewFile = imageObj instanceof File;

                      const imageSrc = isNewFile
                        ? URL.createObjectURL(imageObj)
                        : imageObj?.image
                          ? IMG_URL + imageObj.image
                          : "";

                      if (!imageSrc) return null;

                      return (
                        <div
                          key={imageObj?.id || `${imageObj?.name}-${index}`}
                          className="position-relative ms-2 mt-2"
                          style={{
                            width: "100px",
                            height: "100px",
                          }}
                        >
                          <img
                            src={imageSrc}
                            alt={`Preview ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "6px",
                              border: "1px solid #ddd",
                            }}
                          />

                          <button
                            type="button"
                            onClick={() => handleRemoveImage(index)}
                            style={{
                              position: "absolute",
                              top: "-8px",
                              right: "-8px",
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              border: "none",
                              background: "#dc3545",
                              color: "#fff",
                              fontSize: "18px",
                              fontWeight: "bold",
                              lineHeight: "20px",
                              padding: 0,
                              cursor: "pointer",
                              zIndex: 10,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      );
                    })}
                </div>
              </Row>
            </div>
          </div>

          {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
            <Form.Label>Variant Type</Form.Label>
            <Controller
              className="select-contoller"
              name={`variant_type_id`} // name of the field
              control={control}
              rules={{
                required: "Select Shape",
              }}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderColor: errors?.variant_type_id
                        ? "red"
                        : baseStyles.borderColor,
                    }),
                  }}
                  options={VarientType}
                  onChange={(selectedValue) => {
                    onChange(selectedValue);
                  }}
                  onBlur={onBlur}
                  value={value}
                  ref={ref}
                />
              )}
            />
            {errors.variant_type_id && (
              <span className="text-danger">
                {errors.variant_type_id.message}
              </span>
            )}
          </div> */}

          {/* {Number(variantType?.value) === variant_type.Single ? ( */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>5.{variantType?.label} Variants</h6>
            </div>

            <div className="package-details-section">
              {fields.map((variant, index) => (
                <div key={variant.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={4}>
                      <div className="main-form-section mt-3">
                        <Form.Group>
                          <div className="">
                            <Form.Label>Variant</Form.Label>
                          </div>

                          <Controller
                            className="select-contoller"
                            name={`variants.${index}.metal_id`}
                            control={control}
                            rules={{
                              required: "Select Variant",
                            }}
                            render={({
                              field: { onChange, onBlur, value, ref },
                            }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.variants?.[index]
                                      ?.metal_id
                                      ? "red"
                                      : baseStyles.borderColor,
                                  }),
                                }}
                                options={Metals}
                                onChange={(selectedValue) => {
                                  onChange(selectedValue);
                                }}
                                onBlur={onBlur}
                                value={value}
                                ref={ref}
                              />
                            )}
                          />

                          {errors?.variants?.[index]?.metal_id && (
                            <span className="text-danger">
                              {errors?.variants?.[index]?.metal_id.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Variant MRP</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`variants.${index}.mrp`} // Register color for the variant
                              placeholder="Variant MRP"
                              className={classNames("", {
                                "is-invalid": errors?.variants?.[index]?.mrp,
                              })}
                              {...register(`variants.${index}.mrp`, {
                                required: "Variant MRP is required",
                              })}
                              onKeyDown={(e) => {
                                // Allow backspace, left and right arrow keys
                                if (
                                  e.key === "Backspace" ||
                                  e.key === "ArrowLeft" ||
                                  e.key === "ArrowRight"
                                ) {
                                  return; // Allow the action to continue
                                }

                                // Allow digits and decimal point
                                if (!/[\d.]/.test(e.key)) {
                                  e.preventDefault(); // Block the invalid key
                                }

                                // Prevent multiple decimal points
                                if (
                                  e.key === "." &&
                                  e.target.value.includes(".")
                                ) {
                                  e.preventDefault(); // Block adding another decimal point
                                }
                              }}
                            />
                            {errors?.variants?.[index]?.mrp && (
                              <span className="text-danger">
                                {errors.variants[index].mrp.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Variant Price</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`variants.${index}.price`} // Register color for the variant
                              placeholder="Variant Price"
                              className={classNames("", {
                                "is-invalid": errors?.variants?.[index]?.price,
                              })}
                              {...register(`variants.${index}.price`, {
                                required: "Variant name is required",
                                validate: {
                                  lessThanPrice: (value) => {
                                    const mrp = getValues(
                                      `variants.${index}.mrp`,
                                    );
                                    if (parseFloat(value) >= parseFloat(mrp)) {
                                      return "Price must be less than MRP";
                                    }
                                    return true;
                                  },
                                },
                              })}
                              onKeyDown={(e) => {
                                // Allow backspace, left and right arrow keys
                                if (
                                  e.key === "Backspace" ||
                                  e.key === "ArrowLeft" ||
                                  e.key === "ArrowRight"
                                ) {
                                  return; // Allow the action to continue
                                }

                                // Allow digits and decimal point
                                if (!/[\d.]/.test(e.key)) {
                                  e.preventDefault(); // Block the invalid key
                                }

                                // Prevent multiple decimal points
                                if (
                                  e.key === "." &&
                                  e.target.value.includes(".")
                                ) {
                                  e.preventDefault(); // Block adding another decimal point
                                }
                              }}
                            />
                            {errors?.variants?.[index]?.price && (
                              <span className="text-danger">
                                {errors.variants[index].price.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  {fields.length > 1 && (
                    <button
                      className="mt-3 add-varient"
                      type="button"
                      onClick={() => remove(index)} // Remove the variant
                    >
                      Remove Variant
                    </button>
                  )}
                  <hr />
                </div>
              ))}
            </div>
            <hr />
            <div className="text-center">
              <button
                type="button"
                className="add-varient"
                onClick={() => append({})}
              >
                + Add Variant
              </button>
            </div>
          </div>
          {/* ) : Number(variantType?.value) === variant_type.Double ? (
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5.{variantType?.label} Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            
                            <div className="">
                              <Form.Label>Metal</Form.Label>
                            </div>

                            <Controller
                              className="select-contoller"
                              name={`variants.${index}.metal_id`}
                              control={control}
                              rules={
                                {
                                  required: "Select Metal",
                                }
                              }
                              render={({
                                field: { onChange, onBlur, value, ref },
                              }) => (
                                <Select
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: errors?.variants?.[index]
                                        ?.metal_id
                                        ? "red"
                                        : baseStyles.borderColor,
                                    }),
                                  }}
                                  
                                  options={Metals}
                                  onChange={(selectedValue) => {
                                    onChange(selectedValue);
                                  }}
                                  onBlur={onBlur}
                                  value={value}
                                  ref={ref}
                                />
                              )}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>

                      <DoubleVarient
                        product_id={getValues(`variants.${index}.product_id`)}
                        singleIndex={index}
                        control={control}
                        variantType={variantType}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                    </Row>
                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Variant
                </button>
              </div>
            </div>
          ) : Number(variantType?.value) === variant_type.Triple ? (
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5.{variantType?.label} Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <div className="">
                              <Form.Label>Metal</Form.Label>
                            </div>

                            <Controller
                              className="select-contoller"
                              name={`variants.${index}.metal_id`} 
                              control={control}
                              rules={
                                {
                                  required: "Select Metal",
                                }
                              }
                              render={({
                                field: { onChange, onBlur, value, ref },
                              }) => (
                                <Select
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: errors?.variants?.[index]
                                        ?.metal_id
                                        ? "red"
                                        : baseStyles.borderColor,
                                    }),
                                  }}
                                  // {...field}
                                  options={Metals}
                                  onChange={(selectedValue) => {
                                    onChange(selectedValue);
                                  }}
                                  onBlur={onBlur}
                                  value={value}
                                  ref={ref}
                                />
                              )}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>

                      <DoubleVarient
                        variantType={variantType}
                        singleIndex={index}
                        control={control}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                    </Row>
                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Variant
                </button>
              </div>
            </div>
          ) : null} */}
          {/* warning text-end */}
          <div className="d-flex justify-content-center">
            <div className="text-center mt-4 mx-2">
              <button
                className="Back-button"
                type="submit"
                onClick={() => navigate("/products")}
              >
                {" "}
                Cancel
              </button>
            </div>

            <div className="text-center mt-4 mx-2">
              <button
                className="schedule-button"
                // type="submit"
                onClick={onSubmit}
              >
                Update Product
              </button>
            </div>
          </div>
        </Form>

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
